export default __webpack_public_path__ + "static/media/gallery-fairy.7f540d0a.webp";